import { useTranslation } from 'react-i18next';
import { Badge } from '@cortex/web-design-system/components/ui/Badge';

/**
 * 案件におけるメンバーのロール。担当子チケット種別から判定した開発者 / レビュアーと、
 * 子チケット割当が無い母票を開発リーダーとして引き当てた場合の開発リーダーを持つ。
 */
export interface MemberRole {
  /** 開発子チケットを担当している */
  isDeveloper: boolean;
  /** レビュー派生種別の子チケットを担当している */
  isReviewer: boolean;
  /** この案件の開発リーダー（子チケット担当が無くてもこのロールで一覧に出る） */
  isDevLeader: boolean;
}

/**
 * 担当ロールバッジ（開発者 / レビュアー / 開発リーダー）
 *
 * マイページ・メンバー詳細の担当案件一覧と、全体PJ看板のチームビューで同じ見た目を使うための共通部品。
 * いずれのロールにも当たらない場合は "-" を出す。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain UX
 * @graph-business 案件1行におけるメンバーの担当ロール（開発者/レビュアー/開発リーダー）バッジ表示。担当案件一覧とチームビューで共用
 * @graph-connects none
 */
export function MemberRoleBadges({ role }: { role: MemberRole }) {
  const { t } = useTranslation();
  const none = !role.isDeveloper && !role.isReviewer && !role.isDevLeader;

  return (
    <div className="flex flex-wrap gap-1">
      {role.isDeveloper && (
        <Badge variant="default" size="sm">
          {t('members.detail.roleDeveloper')}
        </Badge>
      )}
      {role.isReviewer && (
        <Badge variant="default" size="sm">
          {t('members.detail.roleReviewer')}
        </Badge>
      )}
      {role.isDevLeader && (
        <Badge variant="default" size="sm">
          {t('members.detail.roleDevLeader')}
        </Badge>
      )}
      {none && <span className="text-[var(--color-text-muted)]">-</span>}
    </div>
  );
}
